import React from "react";
import { Col, Row } from "react-bootstrap";
import { injectIntl } from "@irati/utils/lang";
import { Description, ImageUploader, Url } from "@irati-web/fields/companyNews";
var NewImageForm = function (_a) {
    var companyNewsTileConfig = _a.companyNewsTileConfig, formatMessage = _a.formatMessage, imageError = _a.imageError, removeImageError = _a.removeImageError, updateContent = _a.updateContent;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 6 },
            React.createElement(ImageUploader, { error: imageError, help: formatMessage({ id: "platform.homepage.fields.image.description" }), imageUrl: companyNewsTileConfig.imageUrl, message: formatMessage({ id: "platform.homepage.fields.image.label" }), onUploadSuccess: function (imageUrl) {
                    updateContent(Object.assign({}, companyNewsTileConfig, { imageUrl: imageUrl }));
                    removeImageError();
                } })),
        React.createElement(Col, { xs: 6 },
            React.createElement(Description, { onChange: function (message) {
                    var updatedContent = Object.assign({}, companyNewsTileConfig, { message: message });
                    updateContent(updatedContent);
                }, value: companyNewsTileConfig.message }),
            React.createElement(Url, { onChange: function (url) {
                    updateContent(Object.assign({}, companyNewsTileConfig, { url: url }));
                }, value: companyNewsTileConfig.url }))));
};
export default injectIntl(NewImageForm);
